import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="login"
export default class extends Controller {
  static targets = ["form"]

  connect() {
    console.log("base form validator conntected")
  }

  async clickedSubmit(event){
    event.preventDefault();
    if(!this.formTarget.checkValidity()){
      this.formTarget.classList.add("was-validated")
    }else{
      this.formTarget.submit()
    }
  }
}
